module.exports = __webpack_public_path__ + "img/replay-es.e172d309.png";